module.exports = require("./fr-PF.d.ts");